module.exports = __webpack_public_path__ + "img/idea-committee.f43fbc96.webp";